
import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { IItemListing } from './root.store';
import { waitForNoReason } from './util';
import { generateItemListing } from './util.generator';
import {
    formatDate, ListProviderRefundRequestsRequest,
    ProviderCollectionPayment,
    ProviderCollectionRefundRequest
} from "@enter/core";
import {ClaimGenerator} from "./claim.generator";
import {PatientGenerator} from "./patient.generator";

export class OverpaymentGenerator {

    public collectionRefundRequests: ProviderCollectionRefundRequest[] = [];

    constructor(patientGenerator: PatientGenerator) {
        this.generateEntities(11);
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderCollectionRefundRequest());
    }

    public async loadOverpaymentListing(
        lprrr: ListProviderRefundRequestsRequest,
    ): Promise<IItemListing<ProviderCollectionRefundRequest> | undefined> {
        await waitForNoReason(400);
        return generateItemListing(lprrr, this.collectionRefundRequests);
    }

    private generateProviderCollectionRefundRequest(id: string = faker.string.uuid()): ProviderCollectionPayment {
        const refund = {
            id,
            created: formatDate(faker.date.past(), 'yyyy-MM-dd'),
            patient: {
                patientId: faker.string.uuid(),
                first: faker.person.firstName(),
                middle: _.sample([undefined, faker.person.firstName()]),
                last: faker.person.lastName(),
                suffix: _.sample([undefined, faker.person.suffix()]),
            }
        };
        this.collectionRefundRequests.push(refund);
        return refund;
    }
}